import {Component, Input} from '@angular/core';
import {MpAllergenXBVO, MpDesignationXBVO, MpNutritionsXBVO} from "../../model/xbvo.model";
import {BaseComponent} from "../../base/base.component";

/**
 * App-Component
 */
@Component({
    selector: '<nutritions>',
    template: `
        <div class="EmptyBox1 GrayBack"></div>
        <div class="SoftGrayBack" style="padding: 2px 0 4px 4px;">{{v('nutritions')}}></div>
        <table border="0" cellpadding="0" cellspacing="2" *ngIf="modelNutritions">
            <tr>
                <td class="BsWid100p">{{v('CARBONHYDRATE')}}</td>
                <td>{{formatTwoDecimal(modelNutritions.carbohydrate)}}g</td>
            </tr>
            <tr>
                <td>{{v('ENERGY_KCAL')}}</td>
                <td>{{formatTwoDecimal(modelNutritions.energyKCal)}}kcal</td>
            </tr>
            <tr>
                <td>{{v('ENERGY')}}</td>
                <td>{{formatTwoDecimal(modelNutritions.energy)}}KJ</td>
            </tr>
            <tr>
                <td>{{v('FAT')}}</td>
                <td>{{formatTwoDecimal(modelNutritions.fat)}}g</td>
            </tr>
            <tr>
                <td>{{v('SATURATED_FATTY_ACIDS')}}</td>
                <td>{{formatTwoDecimal(modelNutritions.saturatedFattyAcids)}}g</td>
            </tr>
            <tr>
                <td>{{v('PROTEIN')}}</td>
                <td>{{formatTwoDecimal(modelNutritions.protein)}}g</td>
            </tr>
            <tr>
                <td>{{v('SODIUM')}}</td>
                <td>{{formatTwoDecimal(modelNutritions.sodium)}}g</td>
            </tr>
            <tr>
                <td>{{v('SUGAR')}}</td>
                <td>{{formatTwoDecimal(modelNutritions.sugar)}}g</td>
            </tr>
        </table>
        <div class="EmptyBox10"></div>

    `
})
export class NutritionsComponent extends BaseComponent {

    @Input()
    modelNutritions: MpNutritionsXBVO;

}
